import { Observable } from 'rxjs';

import Paginate from '../interfaces/paginate';
import SystemConfiguration from '../interfaces/systemConfiguration';
import { HttpClient } from './http-client';

export class SystemConfigurationService extends HttpClient {
  public(): Observable<SystemConfiguration[]> {
    return this.get<SystemConfiguration[]>(`/api/system-configurations/public`);
  }

  index(
    page: number = 1,
    sort?: string,
    desc: boolean = false
  ): Observable<Paginate<SystemConfiguration>> {
    return this.get<Paginate<SystemConfiguration>>(
      '/api/internal/system-configurations',
      {
        page,
        sort,
        desc,
      }
    );
  }

  edit(id: string): Observable<SystemConfiguration> {
    return this.get<SystemConfiguration>(
      `/api/internal/system-configurations/${id}`
    );
  }

  update(
    id: string,
    systemConfiguration: SystemConfiguration
  ): Observable<SystemConfiguration> {
    return this.put<SystemConfiguration>(
      `/api/internal/system-configurations/${id}`,
      systemConfiguration
    );
  }

  getAllowedMimeTypes() {
    return this.get<string[]>(`/api/system-configurations/mimeTypes`);
  }
}
